import React, { useEffect, useRef, useState, useContext } from 'react';
import { UserRole, getValidator, colors } from '../../Constants/constants';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FieldError, Controller } from 'react-hook-form';
import { Grid, makeStyles } from '@material-ui/core/';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../Context/UserContext';
import { useFormContext } from 'react-hook-form';
import { DictUserRole } from '../../API/Interfaces/IUserDtos';
import CorporationServiceAPI from '../../API/Services/CorporationServiceAPI';

export interface SelectionType {
	name: string;
	id?: string;
}

export interface ISelectLocationProps {
	userFormType?: DictUserRole;
	locationPropertyName?: string;
	corporationPropertyName?: string;
	onLocationSelected?: any;
	isInDevices?: boolean;
	showOnlyLocations?: boolean;
	selectedLocationId?: string;
	locationOptions?: SelectionType[];
	disableClearable?: boolean;
	isVisibleInAllLocations?: boolean;
	removeLocationOnChangeCorporation?: boolean;
}
const useStyles = makeStyles((theme) => ({
	popupIndicator: {
		color: colors.main,
	},
}));

export default function SelectLocation(props: ISelectLocationProps) {
	const { t } = useTranslation();
	const classes = useStyles(props);
	const data = useFormContext();
	const { setValue, getValues, register, errors, triggerValidation } = data;

	const corporationPropertyName = props.corporationPropertyName ?? 'corporation';
	const locationPropertyName = props.locationPropertyName ?? 'location';

	const { userFormType, isInDevices = false } = props;
	const formLabels = {
		corporation: t('common.form.selectedCorporation'),
		location: t('pages.users.form.location'),
	};
	const [openLocation, setOpenLocation] = useState(false);
	const [openCorporation, setOpenCorporation] = useState(false);
	const [selectedLocation, setSelectedLocation] = useState<SelectionType>({
		name: getValues()[`${locationPropertyName}Name`],
	});
	const [locationOptions, setLocationOptions] = useState<SelectionType[]>(props.locationOptions ?? []);
	const [corporationOptions, setCorporationOptions] = useState<SelectionType[]>([]);

	const loadingCorporations = openCorporation && corporationOptions.length === 0;
	const loadingLocations = props.locationOptions === undefined && openLocation && locationOptions.length === 0;
	const locationsRef = useRef();

	const userContext = useContext(UserContext);
	const workplaceId = userContext.userWorkplaceId && userContext.userWorkplaceId.length > 0 ? userContext.userWorkplaceId : null;

	let showLocations = false;
	let requireLocation = false;
	let isSelectedCorporationAdmin = false;
	let showCorporations = false;
	let requireCorporation = false;

	(() => {
		if (props.showOnlyLocations) {
			showCorporations = false;
			requireCorporation = false;
			showLocations = true;
			requireLocation = false;
		} else {
			switch (userFormType) {
				case DictUserRole.CorporationAdmin:
					showCorporations = true;
					requireCorporation = true;
					showLocations = false;
					isSelectedCorporationAdmin = true;
					requireLocation = true && !isInDevices;
					break;
				case DictUserRole.LocationAdmin:
					showCorporations = true;
					showLocations = true;
					requireCorporation = true;
					requireLocation = true;
					break;
				case DictUserRole.User:
					showCorporations = true;
					requireCorporation = true;
					if (props.isVisibleInAllLocations !== true) {
						showLocations = true;
						requireLocation = true;
					}
					break;
				case DictUserRole.LocationKeeper:
					showCorporations = true;
					requireCorporation = true;
					showLocations = true;
					requireLocation = true;
					break;
				default:
					showCorporations = true;
					showLocations = true;
					requireCorporation = true && !isInDevices;
					requireLocation = true && !isInDevices;
			}

			switch (userContext.userRoles[0]) {
				case UserRole.CorporationAdmin:
					showCorporations = false;
					requireCorporation = false;
					showLocations = true && !isSelectedCorporationAdmin;
					requireLocation = true && !isSelectedCorporationAdmin;

					setValue(`${corporationPropertyName}Id`, workplaceId);
					break;
				case UserRole.LocationAdmin:
					showCorporations = false;
					showLocations = false;
					requireCorporation = false;
					requireLocation = false;
					setValue(`${locationPropertyName}Id`, workplaceId);
					break;
			}
		}
	})();

	useEffect(() => {
		if (props.locationOptions) {
			setLocationOptions(props.locationOptions);
		}
	}, [props.locationOptions]);

	useEffect(() => {
		switch (userContext.userRoles[0]) {
			case UserRole.CorporationAdmin:
				setValue(`${corporationPropertyName}Id`, workplaceId);
				break;
			case UserRole.LocationAdmin:
				setValue(`${locationPropertyName}Id`, workplaceId);
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [workplaceId]);

	useEffect(() => {
		let active = true;

		if (!loadingCorporations) {
			return undefined;
		} else
			(async () => {
				//let response = null;

				let response = await CorporationServiceAPI.GetAll();

				const corporations = response.data;

				if (active && corporations.length > 0)
					setCorporationOptions(Object.keys(corporations).map((key: any) => corporations[key]) as SelectionType[]);
				else setCorporationOptions([{ name: t('common.form.none') }]);
			})();

		return () => {
			active = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadingCorporations]);

	useEffect(() => {
		//let active = true;

		if (!loadingLocations) {
			return undefined;
		} else if (getValues()[`${corporationPropertyName}Id`])
			(async () => {
				//let response: IResponseBaseTDto<AutocompleteDto[]>;

				/*response = await CorporationServiceAPI.GetChainLocationsList(getValues()[`${corporationPropertyName}Id`]);*/

				/*const locations = response.data;

				if (active && locations.length > 0)
					setLocationOptions(Object.keys(locations).map((key: any) => locations[key]) as SelectionType[]);
				else setLocationOptions([{ name: t('common.form.none') }]);*/
			})();

		return () => {
		//	active = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadingLocations]);

	useEffect(() => {
		if (!openLocation && !props.locationOptions) {
			setLocationOptions([]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [openLocation, props.locationOptions]);

	useEffect(() => {
		if (!openCorporation) {
			setCorporationOptions([]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [openCorporation]);

	useEffect(() => {
		if (props.selectedLocationId) {
			const locationName = locationOptions.find((x) => x.id === props.selectedLocationId)?.name;
			if (locationName) {
				setSelectedLocation({ name: locationName });
			}
		}
	}, [props.selectedLocationId, locationOptions]);

	const formValidators = {
		corporationId: getValidator(t, null, null, props.corporationPropertyName ? false : requireCorporation),
		locationId: getValidator(t, null, null, props.locationPropertyName ? false : requireLocation),
	};

	return (
		<>
			<input name='corporationId' ref={register(formValidators.corporationId)} hidden={true} />
			{!showCorporations && !showLocations ? (
				<>
					<input name='locationId' ref={register(formValidators.locationId)} hidden={true} />
				</>
			) : null}
			{showCorporations && (
				<Grid item xs={6}>
					<Autocomplete
						classes={{
							popupIndicator: classes.popupIndicator,
						}}
						disableClearable={props.disableClearable ?? true}
						noOptionsText={t('common.form.none')}
						loadingText={t('common.form.loading')}
						open={openCorporation}
						onOpen={() => setOpenCorporation(true)}
						onClose={() => setOpenCorporation(false)}
						getOptionSelected={(option, value) => option.name === value.name}
						onChange={(e: any, v: any) => {
							if (v?.id) {
								if (errors[`${corporationPropertyName}Id`]) {
									errors[`${corporationPropertyName}Id`] = undefined;
								}
								setValue(`${corporationPropertyName}Id`, v?.id);
								setValue(`${corporationPropertyName}Name`, v?.name);
								setSelectedLocation({ name: '' });
								setValue(`${locationPropertyName}Id`, null);
								triggerValidation(`${corporationPropertyName}Id`);
								
								if (typeof props.onLocationSelected === 'function' && (!v || props.removeLocationOnChangeCorporation))
									props.onLocationSelected(null);
							}
						}}
						getOptionLabel={(option) => option.name || ''}
						options={corporationOptions}
						defaultValue={{ name: getValues()[`${corporationPropertyName}Name`] }}
						loading={loadingCorporations}
						renderInput={(params) => (
							<Controller
								as={
									<TextField
										error={errors[`${corporationPropertyName}Id`] !== undefined}
										helperText={(errors[`${corporationPropertyName}Id`] as FieldError)?.message}
										{...params}
										label={formLabels.corporation}
										fullWidth
										InputProps={{
											...params.InputProps,
											endAdornment: (
												<React.Fragment>
													{loadingCorporations ? <CircularProgress color='inherit' size={20} /> : null}
													{params.InputProps.endAdornment}
												</React.Fragment>
											),
										}}
									/>
								}
								name='corporationId'
							/>
						)}
						getOptionDisabled={(option) => option.id === undefined}
					/>
				</Grid>
			)}

			{showLocations && (
				<>
					<input name='locationId' ref={register(formValidators.locationId)} hidden={true} />
					<Grid item xs={props.showOnlyLocations ? 12 : 6}>
						<Autocomplete
							disableClearable={props.disableClearable ?? true}
							classes={{
								popupIndicator: classes.popupIndicator,
							}}
							noOptionsText={t('common.form.none')}
							loadingText={t('common.form.loading')}
							open={openLocation}
							onOpen={() => setOpenLocation(true)}
							onClose={() => setOpenLocation(false)}
							innerRef={locationsRef}
							getOptionSelected={(option, value) => option.name === value.name}
							onChange={(e: any, v: any) => {
								if (v?.id || props.disableClearable === false) {
									if (errors[`${locationPropertyName}Id`]) {
										errors[`${locationPropertyName}Id`] = undefined;
									}
									setValue(`${locationPropertyName}Id`, v?.id);
									setValue(`${locationPropertyName}Name`, v?.name);
									triggerValidation(`${locationPropertyName}Id`);
									setSelectedLocation(v);
									setValue('locationName', v?.name);
									if (typeof props.onLocationSelected === 'function') props.onLocationSelected(v);
								}
							}}
							getOptionLabel={(option) => option.name || ''}
							options={locationOptions}
							defaultValue={{ name: getValues()[`${locationPropertyName}Name`] }}
							disabled={
								props.showOnlyLocations !== undefined
									? !props.showOnlyLocations
									: getValues()[`${corporationPropertyName}Id`] === ''
							}
							value={selectedLocation}
							loading={loadingLocations}
							renderInput={(params) => (
								<Controller
									as={
										<TextField
											error={errors[`${locationPropertyName}Id`] !== undefined}
											helperText={(errors[`${locationPropertyName}Id`] as FieldError)?.message}
											{...params}
											label={formLabels.location}
											fullWidth
											InputProps={{
												...params.InputProps,
												endAdornment: (
													<React.Fragment>
														{loadingLocations ? <CircularProgress color='inherit' size={20} /> : null}
														{params.InputProps.endAdornment}
													</React.Fragment>
												),
											}}
										/>
									}
									name='locationId'
								/>
							)}
							getOptionDisabled={(option) => option.id === undefined}
						/>
					</Grid>
				</>
			)}
		</>
	);
}
